module.exports = [
	{
		"fund_id": "FSUSA00B4P",
		"investment_vehicle_id": "FEUSA0000F",
		"ticker": "IVW",
		"fund_legal_name": "iShares S&P 500 Growth ETF",
		"morningstar_category_name": "Large Growth",
		"fund_net_assets": 51733125012,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 1,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 2,
		"c2f5coogutweight": 0.043782079936973264,
		"cl_weight": 0.28738145994416797,
		"fossil_bank_score": 1.1265,
		"fossil_insure_score": 20.3878,
		"wff_mil_weight": 0.03223832933691092,
		"mmc_weight": 0.03223832933691092,
		"cm_weight": 0.007615501649340812,
		"nw_weight": 0.01279130407877091,
		"wff_civ_weight": 0.011631413583138756,
		"gm_weight": 0,
		"gr_weight": 0.011631413583138756,
		"t_all_weight": 0.007818347571032183,
		"to_weight": 0.007818347571032183,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0.018688282418084005,
		"po_consumer_weight": 0.08856067111018553,
		"pp_weight": 0.22888176098579288,
		"borders_weight": 0.20359150976216886,
		"pp_high_weight": 0.004856768323558611,
		"borders_high_weight": 0.01920154258120421,
		"pff_all_weight": 0.2538086380257235,
		"pff_all_high_weight": 0.01920154258120421,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.54087361825188,
		"gef_score_a": 25.530336021483965,
		"gef_score_b": 9.220849401562392,
		"gef_score_c": 18.19071265526436,
		"gef_score_d": 0.5989755399260691,
		"gef_score_a_norm": 63.82584005370992,
		"gef_score_b_norm": 30.73616467187464,
		"gef_score_c_norm": 90.9535632763218,
		"gef_score_d_norm": 5.989755399260691,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": 2.21411,
		"trailing_return_m3": -8.91764,
		"trailing_return_m6": -0.11849,
		"trailing_return_y1": 17.29265,
		"trailing_return_y3": 13.26247,
		"trailing_return_y5": 15.83492,
		"trailing_return_y10": 13.98874,
		"trailing_return_y15": 14.44758,
		"trailing_return_y20": 11.5045,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "S&P 500 Growth",
		"footprint": 22.882636213323696,
		"intensity": 71.94591785242196,
		"name": "IVW - iShares S&P 500 Growth ETF",
		"label": "IVW - iShares S&P 500 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B4Q",
		"investment_vehicle_id": "FEUSA0000G",
		"ticker": "IVE",
		"fund_legal_name": "iShares S&P 500 Value ETF",
		"morningstar_category_name": "Large Value",
		"fund_net_assets": 36614193341,
		"grade_fossil": 5,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 1,
		"grade_dei": 2,
		"grade_rji": 1,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.1276071828138481,
		"cl_weight": 0.21476377695149165,
		"fossil_bank_score": 27.3661,
		"fossil_insure_score": 31.1613,
		"wff_mil_weight": 0.03850453081624634,
		"mmc_weight": 0.03850453081624634,
		"cm_weight": 0.022401522425617597,
		"nw_weight": 0.03557676643064616,
		"wff_civ_weight": 0.008903368043728155,
		"gm_weight": 0.0028729021448246923,
		"gr_weight": 0.0060304658989034626,
		"t_all_weight": 0.029270301355746414,
		"to_weight": 0.007651408117117306,
		"tm_weight": 0.02161889323862911,
		"po_producer_weight": 0.003619836305570365,
		"po_financier_weight": 0.033127680046412346,
		"po_consumer_weight": 0.14661750612377517,
		"pp_weight": 0.1511705527991717,
		"borders_weight": 0.14008745156397548,
		"pp_high_weight": 0.0015026458963915907,
		"borders_high_weight": 0.01852671748602917,
		"pff_all_weight": 0.19340910566437872,
		"pff_all_high_weight": 0.01852671748602917,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 56.18751576456491,
		"gef_score_a": 27.829624932124744,
		"gef_score_b": 9.093418990933804,
		"gef_score_c": 18.561567539219705,
		"gef_score_d": 0.7029043022880002,
		"gef_score_a_norm": 69.57406233031186,
		"gef_score_b_norm": 30.311396636446013,
		"gef_score_c_norm": 92.80783769609853,
		"gef_score_d_norm": 7.0290430228800025,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": -3.58157,
		"trailing_return_m3": -6.06676,
		"trailing_return_m6": -4.75378,
		"trailing_return_y1": 4.81248,
		"trailing_return_y3": 9.62064,
		"trailing_return_y5": 13.81001,
		"trailing_return_y10": 9.36953,
		"trailing_return_y15": 10.5176,
		"trailing_return_y20": 8.25604,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "S&P 500 Value",
		"footprint": 147.335576324996,
		"intensity": 220.5813107990886,
		"name": "IVE - iShares S&P 500 Value ETF",
		"label": "IVE - iShares S&P 500 Value ETF"
	},
	{
		"fund_id": "FSUSA00B5I",
		"investment_vehicle_id": "FEUSA00018",
		"ticker": "IWO",
		"fund_legal_name": "iShares Russell 2000 Growth ETF",
		"morningstar_category_name": "Small Growth",
		"fund_net_assets": 10714697330,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 3,
		"grade_guns": 3,
		"c2f5coogutweight": 0.030063860307292165,
		"cl_weight": 0,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.024814539953636607,
		"mmc_weight": 0.024814539953636607,
		"cm_weight": 0.0044978490705989424,
		"nw_weight": 0.011391292213058693,
		"wff_civ_weight": 0.0007237263934982836,
		"gm_weight": 0.0001793192211491586,
		"gr_weight": 0.000544407172349125,
		"t_all_weight": 0.0007408358530965597,
		"to_weight": 0.0007408358530965597,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0020833778253616193,
		"pp_weight": 0.0011703984439440378,
		"borders_weight": 0.009254159658886906,
		"pp_high_weight": 0.0009565991808867385,
		"borders_high_weight": 0.0032322204136549437,
		"pff_all_weight": 0.009616374705072908,
		"pff_all_high_weight": 0.003380636196783645,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 36.92054171701996,
		"gef_score_a": 19.230866374227237,
		"gef_score_b": 3.1759052458912205,
		"gef_score_c": 14.498743592710571,
		"gef_score_d": 0.015026504191228444,
		"gef_score_a_norm": 48.07716593556809,
		"gef_score_b_norm": 10.586350819637401,
		"gef_score_c_norm": 72.49371796355287,
		"gef_score_d_norm": 0.15026504191228443,
		"prospectus_net_expense_ratio": 0.24,
		"trailing_return_m1": -0.64585,
		"trailing_return_m3": -14.38972,
		"trailing_return_m6": -9.00571,
		"trailing_return_y1": 2.33749,
		"trailing_return_y3": 5.00534,
		"trailing_return_y5": 7.52958,
		"trailing_return_y10": 6.38601,
		"trailing_return_y15": 9.19405,
		"trailing_return_y20": 8.38946,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell 2000 Growth",
		"footprint": 138.53454201517556,
		"intensity": 156.10505164940264,
		"name": "IWO - iShares Russell 2000 Growth ETF",
		"label": "IWO - iShares Russell 2000 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B5J",
		"investment_vehicle_id": "FEUSA00019",
		"ticker": "IWN",
		"fund_legal_name": "iShares Russell 2000 Value ETF",
		"morningstar_category_name": "Small Value",
		"fund_net_assets": 10680380959,
		"grade_fossil": 5,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.11358793246269877,
		"cl_weight": 0.006300526393150287,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.031612216985470565,
		"mmc_weight": 0.031612216985470565,
		"cm_weight": 0.0008266302037643204,
		"nw_weight": 0.0035627371556947733,
		"wff_civ_weight": 0.003048485855460509,
		"gm_weight": 0.0013816364292061711,
		"gr_weight": 0.001666849426254338,
		"t_all_weight": 0.0036271889966812253,
		"to_weight": 0.0013525304074396404,
		"tm_weight": 0.002274658589241585,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0026251419877724217,
		"pp_weight": 0.009524878272887609,
		"borders_weight": 0.007392670019266503,
		"pp_high_weight": 0.006070805956217341,
		"borders_high_weight": 0.006210268340733292,
		"pff_all_weight": 0.011264540017681774,
		"pff_all_high_weight": 0.006628066022478294,
		"pff_all_extreme_weight": 0.005653008274472339,
		"gef_score_norm": 39.782249232168056,
		"gef_score_a": 20.5567716931523,
		"gef_score_b": 3.6312448217151454,
		"gef_score_c": 15.550388221236618,
		"gef_score_d": 0.04384449606705797,
		"gef_score_a_norm": 51.39192923288075,
		"gef_score_b_norm": 12.104149405717152,
		"gef_score_c_norm": 77.75194110618308,
		"gef_score_d_norm": 0.4384449606705797,
		"prospectus_net_expense_ratio": 0.24,
		"trailing_return_m1": -4.0162,
		"trailing_return_m3": -13.25355,
		"trailing_return_m6": -11.0512,
		"trailing_return_y1": -0.90434,
		"trailing_return_y3": 1.16515,
		"trailing_return_y5": 11.50652,
		"trailing_return_y10": 5.70001,
		"trailing_return_y15": 7.24707,
		"trailing_return_y20": 6.71457,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell 2000 Value",
		"footprint": 210.67117372007064,
		"intensity": 146.1275380116073,
		"name": "IWN - iShares Russell 2000 Value ETF",
		"label": "IWN - iShares Russell 2000 Value ETF"
	},
	{
		"fund_id": "FSUSA00B5L",
		"investment_vehicle_id": "FEUSA0001B",
		"ticker": "IWF",
		"fund_legal_name": "iShares Russell 1000 Growth ETF",
		"morningstar_category_name": "Large Growth",
		"fund_net_assets": 98083084894,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 1,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 1,
		"grade_hrc": 1,
		"grade_prison_industrial_complex": 4,
		"grade_military": 3,
		"grade_guns": 2,
		"c2f5coogutweight": 0.012619068043706206,
		"cl_weight": 0.3757063038450923,
		"fossil_bank_score": 0.8521,
		"fossil_insure_score": 0.0953,
		"wff_mil_weight": 0.01009870099911919,
		"mmc_weight": 0.01009870099911919,
		"cm_weight": 0.0026262290784789272,
		"nw_weight": 0.006398121359217688,
		"wff_civ_weight": 0.00003560349708511141,
		"gm_weight": 0,
		"gr_weight": 0.00003560349708511141,
		"t_all_weight": 0,
		"to_weight": 0,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0.00029674956249586257,
		"po_consumer_weight": 0.11681107871210944,
		"pp_weight": 0.2545870542392178,
		"borders_weight": 0.25406406168749157,
		"pp_high_weight": 0.0030078724388776785,
		"borders_high_weight": 0.014107203757195206,
		"pff_all_weight": 0.2739766893776374,
		"pff_all_high_weight": 0.014107203757195206,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.87650567836033,
		"gef_score_a": 25.374953657501372,
		"gef_score_b": 9.542813977079385,
		"gef_score_c": 18.247129273105,
		"gef_score_d": 0.7116087706666209,
		"gef_score_a_norm": 63.43738414375343,
		"gef_score_b_norm": 31.80937992359795,
		"gef_score_c_norm": 91.23564636552499,
		"gef_score_d_norm": 7.116087706666209,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 1.75498,
		"trailing_return_m3": -10.18861,
		"trailing_return_m6": -1.65516,
		"trailing_return_y1": 14.32641,
		"trailing_return_y3": 15.41081,
		"trailing_return_y5": 17.0267,
		"trailing_return_y10": 15.06026,
		"trailing_return_y15": 15.13087,
		"trailing_return_y20": 12.20832,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell 1000 Growth",
		"footprint": 27.104039919030285,
		"intensity": 72.28267458266703,
		"name": "IWF - iShares Russell 1000 Growth ETF",
		"label": "IWF - iShares Russell 1000 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B5M",
		"investment_vehicle_id": "FEUSA0001C",
		"ticker": "IWD",
		"fund_legal_name": "iShares Russell 1000 Value ETF",
		"morningstar_category_name": "Large Value",
		"fund_net_assets": 60079800481,
		"grade_fossil": 5,
		"grade_deforestation": 3,
		"grade_tobacco": 5,
		"grade_gender_equality": 2,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.16074630739260365,
		"cl_weight": 0.06780983007056067,
		"fossil_bank_score": 26.1346,
		"fossil_insure_score": 50.6488,
		"wff_mil_weight": 0.0684533368214603,
		"mmc_weight": 0.0684533368214603,
		"cm_weight": 0.029051610120611266,
		"nw_weight": 0.044220399392191335,
		"wff_civ_weight": 0.020681964643501163,
		"gm_weight": 0.0028484375496419653,
		"gr_weight": 0.017833527093859197,
		"t_all_weight": 0.035781934100634724,
		"to_weight": 0.015149433257432848,
		"tm_weight": 0.020632500843201885,
		"po_producer_weight": 0.003433558896275415,
		"po_financier_weight": 0.049856772461120975,
		"po_consumer_weight": 0.10075598420938361,
		"pp_weight": 0.08776341335549465,
		"borders_weight": 0.05467419011031172,
		"pp_high_weight": 0.0033702613038487806,
		"borders_high_weight": 0.023766988845490725,
		"pff_all_weight": 0.1346273844253885,
		"pff_all_high_weight": 0.023766988845490725,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.877430155374604,
		"gef_score_a": 27.404965442484126,
		"gef_score_b": 7.940038608352081,
		"gef_score_c": 18.0627170207345,
		"gef_score_d": 0.4697090837984675,
		"gef_score_a_norm": 68.51241360621032,
		"gef_score_b_norm": 26.466795361173606,
		"gef_score_c_norm": 90.3135851036725,
		"gef_score_d_norm": 4.697090837984675,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": -3.06036,
		"trailing_return_m3": -5.39751,
		"trailing_return_m6": -1.94818,
		"trailing_return_y1": 8.35226,
		"trailing_return_y3": 7.42952,
		"trailing_return_y5": 12.8029,
		"trailing_return_y10": 8.17811,
		"trailing_return_y15": 9.81322,
		"trailing_return_y20": 7.76002,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell 1000 Value",
		"footprint": 163.94657295457372,
		"intensity": 244.40950089263998,
		"name": "IWD - iShares Russell 1000 Value ETF",
		"label": "IWD - iShares Russell 1000 Value ETF"
	},
	{
		"fund_id": "FSUSA00B6U",
		"investment_vehicle_id": "FEUSA0002J",
		"ticker": "OEF",
		"fund_legal_name": "iShares S&P 100 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 16683630032,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 1,
		"grade_dei": 1,
		"grade_rji": 1,
		"grade_hrc": 1,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 2,
		"c2f5coogutweight": 0.06346424866643073,
		"cl_weight": 0.3343240497376153,
		"fossil_bank_score": 18.9717,
		"fossil_insure_score": 30.5448,
		"wff_mil_weight": 0.029326631067410933,
		"mmc_weight": 0.029326631067410933,
		"cm_weight": 0.014249658464056111,
		"nw_weight": 0.02488339812738791,
		"wff_civ_weight": 0.012681578454312026,
		"gm_weight": 0,
		"gr_weight": 0.012681578454312026,
		"t_all_weight": 0.025819723519869706,
		"to_weight": 0.011022775610229735,
		"tm_weight": 0.014796947909639972,
		"po_producer_weight": 0,
		"po_financier_weight": 0.03665024399405466,
		"po_consumer_weight": 0.143807229703823,
		"pp_weight": 0.2584945560327789,
		"borders_weight": 0.23437391588381692,
		"pp_high_weight": 0,
		"borders_high_weight": 0.017433132497871512,
		"pff_all_weight": 0.3001920508444722,
		"pff_all_high_weight": 0.017433132497871512,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 55.94887998930279,
		"gef_score_a": 26.7475052502418,
		"gef_score_b": 10.066606837329774,
		"gef_score_c": 18.313190053015738,
		"gef_score_d": 0.821577848708618,
		"gef_score_a_norm": 66.8687631256045,
		"gef_score_b_norm": 33.55535612443258,
		"gef_score_c_norm": 91.56595026507868,
		"gef_score_d_norm": 8.215778487086181,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": -0.47766,
		"trailing_return_m3": -8.44295,
		"trailing_return_m6": -1.71705,
		"trailing_return_y1": 14.14453,
		"trailing_return_y3": 14.20405,
		"trailing_return_y5": 16.53593,
		"trailing_return_y10": 13.24362,
		"trailing_return_y15": 13.31868,
		"trailing_return_y20": 10.31637,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "S&P 100",
		"footprint": 50.295241468364594,
		"intensity": 120.77831715622968,
		"name": "OEF - iShares S&P 100 ETF",
		"label": "OEF - iShares S&P 100 ETF"
	},
	{
		"fund_id": "FSUSA04YKB",
		"investment_vehicle_id": "FEUSA04ACN",
		"ticker": "ILCB",
		"fund_legal_name": "iShares Morningstar U.S. Equity ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 937812072,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.08202063092099969,
		"cl_weight": 0.24287147551225055,
		"fossil_bank_score": 13.5082,
		"fossil_insure_score": 24.286,
		"wff_mil_weight": 0.03616253083709071,
		"mmc_weight": 0.03616253083709071,
		"cm_weight": 0.01539908029917728,
		"nw_weight": 0.023910373308721783,
		"wff_civ_weight": 0.010179004664617339,
		"gm_weight": 0.0014238122565085715,
		"gr_weight": 0.008755192408108767,
		"t_all_weight": 0.01737744371867575,
		"to_weight": 0.007411286463093018,
		"tm_weight": 0.009966157255582734,
		"po_producer_weight": 0.001694182255825681,
		"po_financier_weight": 0.0248813544199983,
		"po_consumer_weight": 0.11273732085714401,
		"pp_weight": 0.18483807526958443,
		"borders_weight": 0.16847091923381458,
		"pp_high_weight": 0.0030989638827704623,
		"borders_high_weight": 0.018918167529310904,
		"pff_all_weight": 0.21778485084083934,
		"pff_all_high_weight": 0.018918167529310904,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.31973791700349,
		"gef_score_a": 26.43886623719976,
		"gef_score_b": 9.002509657664428,
		"gef_score_c": 18.25280566960415,
		"gef_score_d": 0.6255563525283256,
		"gef_score_a_norm": 66.0971655929994,
		"gef_score_b_norm": 30.008365525548093,
		"gef_score_c_norm": 91.26402834802076,
		"gef_score_d_norm": 6.2555635252832555,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": -0.46826,
		"trailing_return_m3": -7.81756,
		"trailing_return_m6": -1.67646,
		"trailing_return_y1": 12.0839,
		"trailing_return_y3": 12.08062,
		"trailing_return_y5": 15.10871,
		"trailing_return_y10": 11.63408,
		"trailing_return_y15": 12.67722,
		"trailing_return_y20": 10.32469,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Morningstar U.S. Equity",
		"footprint": 92.78032831872646,
		"intensity": 180.94636729905469,
		"name": "ILCB - iShares Morningstar U.S. Equity ETF",
		"label": "ILCB - iShares Morningstar U.S. Equity ETF"
	},
	{
		"fund_id": "FSUSA04YKE",
		"investment_vehicle_id": "FEUSA04ACQ",
		"ticker": "IMCB",
		"fund_legal_name": "iShares Morningstar Mid-Cap ETF",
		"morningstar_category_name": "Mid-Cap Blend",
		"fund_net_assets": 992425087,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 1,
		"grade_gender_equality": 3,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 5,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 2,
		"c2f5coogutweight": 0.14183150477197315,
		"cl_weight": 0.04602365823908355,
		"fossil_bank_score": 1.1531,
		"fossil_insure_score": 12.9658,
		"wff_mil_weight": 0.02936407223283345,
		"mmc_weight": 0.02936407223283345,
		"cm_weight": 0.007044920021587984,
		"nw_weight": 0.0160044161513778,
		"wff_civ_weight": 0.0010325831973928884,
		"gm_weight": 0,
		"gr_weight": 0.0010325831973928884,
		"t_all_weight": 0,
		"to_weight": 0,
		"tm_weight": 0,
		"po_producer_weight": 0.007896884766522318,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.05126762835407231,
		"pp_weight": 0.03105559891577528,
		"borders_weight": 0.03134857965996153,
		"pp_high_weight": 0.007494013242519689,
		"borders_high_weight": 0.01884167361668787,
		"pff_all_weight": 0.046950754734028495,
		"pff_all_high_weight": 0.01884167361668787,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 49.779531847324684,
		"gef_score_a": 25.45936378365288,
		"gef_score_b": 6.379573639478951,
		"gef_score_c": 17.77512087859306,
		"gef_score_d": 0.1654735455913362,
		"gef_score_a_norm": 63.648409459132196,
		"gef_score_b_norm": 21.265245464929837,
		"gef_score_c_norm": 88.8756043929653,
		"gef_score_d_norm": 1.6547354559133622,
		"prospectus_net_expense_ratio": 0.04,
		"trailing_return_m1": -1.38614,
		"trailing_return_m3": -7.65077,
		"trailing_return_m6": -2.58757,
		"trailing_return_y1": 7.1995,
		"trailing_return_y3": 7.08366,
		"trailing_return_y5": 12.77602,
		"trailing_return_y10": 8.41416,
		"trailing_return_y15": 10.98903,
		"trailing_return_y20": 9.52278,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Morningstar Mid-Cap",
		"footprint": 211.17432119436003,
		"intensity": 276.1060472580773,
		"name": "IMCB - iShares Morningstar Mid-Cap ETF",
		"label": "IMCB - iShares Morningstar Mid-Cap ETF"
	},
	{
		"fund_id": "FSUSA04YKH",
		"investment_vehicle_id": "FEUSA04ACT",
		"ticker": "ISCB",
		"fund_legal_name": "iShares Morningstar Small-Cap ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 214779684,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 3,
		"c2f5coogutweight": 0.061995915572382224,
		"cl_weight": 0.00926580131572825,
		"fossil_bank_score": 0,
		"fossil_insure_score": 1.021,
		"wff_mil_weight": 0.0449306530308562,
		"mmc_weight": 0.0449306530308562,
		"cm_weight": 0.0034712214020613643,
		"nw_weight": 0.016330609685432686,
		"wff_civ_weight": 0.0013697786867030977,
		"gm_weight": 0.0007613898667629923,
		"gr_weight": 0.0006083888199401052,
		"t_all_weight": 0.002664029147119434,
		"to_weight": 0.0005819906049272566,
		"tm_weight": 0.002082038542192177,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.011491438165007724,
		"pp_weight": 0.011939841178350974,
		"borders_weight": 0.017868055093965808,
		"pp_high_weight": 0.0038901491932621024,
		"borders_high_weight": 0.007610974814701284,
		"pff_all_weight": 0.02062903549136977,
		"pff_all_high_weight": 0.007773638499297862,
		"pff_all_extreme_weight": 0.0015275692830852778,
		"gef_score_norm": 41.6398745420068,
		"gef_score_a": 21.62807095142704,
		"gef_score_b": 4.206083162871727,
		"gef_score_c": 15.728970433819432,
		"gef_score_d": 0.07674999388647262,
		"gef_score_a_norm": 54.07017737856761,
		"gef_score_b_norm": 14.020277209572424,
		"gef_score_c_norm": 78.64485216909716,
		"gef_score_d_norm": 0.7674999388647262,
		"prospectus_net_expense_ratio": 0.04,
		"trailing_return_m1": -2.55875,
		"trailing_return_m3": -12.84228,
		"trailing_return_m6": -8.26409,
		"trailing_return_y1": 2.51233,
		"trailing_return_y3": 4.418,
		"trailing_return_y5": 9.87998,
		"trailing_return_y10": 5.76312,
		"trailing_return_y15": 8.057,
		"trailing_return_y20": 7.68515,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Morningstar Small-Cap",
		"footprint": 153.85328193312995,
		"intensity": 146.31857820609906,
		"name": "ISCB - iShares Morningstar Small-Cap ETF",
		"label": "ISCB - iShares Morningstar Small-Cap ETF"
	},
	{
		"fund_id": "FSUSA06EC6",
		"investment_vehicle_id": "FEUSA04ADS",
		"ticker": "IWC",
		"fund_legal_name": "iShares Micro-Cap ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 762504882,
		"grade_fossil": 3,
		"grade_deforestation": 1,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 3,
		"grade_guns": 4,
		"c2f5coogutweight": 0.03405158312745216,
		"cl_weight": 0,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.022811773275768884,
		"mmc_weight": 0.022811773275768884,
		"cm_weight": 0.0012329159243834155,
		"nw_weight": 0.002206239247992183,
		"wff_civ_weight": 0.0034418522655632524,
		"gm_weight": 0.003209804056284658,
		"gr_weight": 0.00023204820927859445,
		"t_all_weight": 0.002979615008329593,
		"to_weight": 0.002979615008329593,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0,
		"pp_weight": 0.002474017395664508,
		"borders_weight": 0.00221350961618201,
		"pp_high_weight": 0.00215316542927959,
		"borders_high_weight": 0.00215316542927959,
		"pff_all_weight": 0.002534361582566928,
		"pff_all_high_weight": 0.00215316542927959,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 12.932970825912122,
		"gef_score_a": 4.469340975348021,
		"gef_score_b": 1.8436441793636404,
		"gef_score_c": 6.619985671200459,
		"gef_score_d": 0,
		"gef_score_a_norm": 11.17335243837005,
		"gef_score_b_norm": 6.145480597878802,
		"gef_score_c_norm": 33.099928356002295,
		"gef_score_d_norm": 0,
		"prospectus_net_expense_ratio": 0.6,
		"trailing_return_m1": -0.4862,
		"trailing_return_m3": -14.9375,
		"trailing_return_m6": -10.48105,
		"trailing_return_y1": 0.16806,
		"trailing_return_y3": -0.26232,
		"trailing_return_y5": 8.5307,
		"trailing_return_y10": 4.84435,
		"trailing_return_y15": 7.20708,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell Microcap",
		"footprint": 243.54934065647353,
		"intensity": 169.31538594444189,
		"name": "IWC - iShares Micro-Cap ETF",
		"label": "IWC - iShares Micro-Cap ETF"
	},
	{
		"fund_id": "FSUSA0A2N9",
		"investment_vehicle_id": "F000003WKP",
		"ticker": "IWL",
		"fund_legal_name": "iShares Russell Top 200 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 1531674397,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 1,
		"grade_dei": 1,
		"grade_rji": 1,
		"grade_hrc": 1,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07280279207499377,
		"cl_weight": 0.28999300987736476,
		"fossil_bank_score": 16.3349,
		"fossil_insure_score": 29.3937,
		"wff_mil_weight": 0.03683900398187848,
		"mmc_weight": 0.03683900398187848,
		"cm_weight": 0.01718121948005568,
		"nw_weight": 0.02534975602542637,
		"wff_civ_weight": 0.012182377187699196,
		"gm_weight": 0.0016546834564120174,
		"gr_weight": 0.010527693731287178,
		"t_all_weight": 0.02143331217819951,
		"to_weight": 0.009149614436366686,
		"tm_weight": 0.012283697741832827,
		"po_producer_weight": 0,
		"po_financier_weight": 0.03028805566721252,
		"po_consumer_weight": 0.12674775129692406,
		"pp_weight": 0.22020891835386497,
		"borders_weight": 0.19327675500858965,
		"pp_high_weight": 0.0018134940521713047,
		"borders_high_weight": 0.012014148136807486,
		"pff_all_weight": 0.2503294616980063,
		"pff_all_high_weight": 0.012014148136807486,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 55.6851599475197,
		"gef_score_a": 26.898829420720578,
		"gef_score_b": 9.612711641516286,
		"gef_score_c": 18.442364411919524,
		"gef_score_d": 0.731254473357255,
		"gef_score_a_norm": 67.24707355180144,
		"gef_score_b_norm": 32.04237213838762,
		"gef_score_c_norm": 92.21182205959761,
		"gef_score_d_norm": 7.31254473357255,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": -0.48561,
		"trailing_return_m3": -7.92847,
		"trailing_return_m6": -1.39986,
		"trailing_return_y1": 13.183,
		"trailing_return_y3": 13.27761,
		"trailing_return_y5": 16.05176,
		"trailing_return_y10": 13.03108,
		"trailing_return_y15": 13.35209,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-04-30T00:00:00.000Z",
		"index_name": "Russell Top 200",
		"footprint": 60.02532538962697,
		"intensity": 132.94129555375534,
		"name": "IWL - iShares Russell Top 200 ETF",
		"label": "IWL - iShares Russell Top 200 ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/ExtendedBenchmarks.json
// module id = 926
// module chunks = 0